<template>
  <div class="user-center__content" :class="{'is-overflow-hidden': hidden}">
    <slot />
  </div>
</template>

<script>
export default {
    name: 'UserCenterContentSlot',
    props: {
      hidden: {
        type: Boolean,
        default: false
      }
    }
}
</script>

<style>
.user-center__content{
    flex: 1;
    padding-bottom: 98px;
    background-color: var(--src-text-color-white);
    box-shadow: 0px 4px 9px -3px rgba(0,0,0,0.2);
    border-radius: 12px;
    overflow-x: auto;
}

.user-center__content.is-overflow-hidden{
   overflow: hidden;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/UserCenterContentSlot.vue